import * as React from 'react'
import Svg, { Path } from 'react-native-svg'
export const MonitorIcon = () => (
  <Svg width={40} height={41} viewBox='0 0 40 41' fill='none'>
    <Path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.6369 31.5952V34.1522L13.5179 34.1547C12.8114 34.1547 12.2381 34.7294 12.2381 35.4345C12.2381 36.1409 12.8127 36.7143 13.5179 36.7143L26.3155 36.7079C27.0219 36.7079 27.5952 36.1345 27.5952 35.4281C27.5952 34.7217 27.0206 34.1483 26.3155 34.1483L21.1964 34.1509V31.5952H33.994C35.0127 31.5952 35.9892 31.1908 36.7084 30.4703C37.4289 29.7511 37.8333 28.7746 37.8333 27.7559V9.83928C37.8333 8.82059 37.4289 7.84414 36.7084 7.12491C35.9892 6.4044 35.0127 6 33.994 6H5.83928C4.82059 6 3.84414 6.4044 3.12491 7.12491C2.4044 7.84414 2 8.82059 2 9.83928C2 14.2711 2 23.3241 2 27.7559C2 28.7746 2.4044 29.7511 3.12491 30.4703C3.84414 31.1908 4.82059 31.5952 5.83928 31.5952H18.6369ZM4.55952 26.4762V27.7559C4.55952 28.0951 4.6939 28.4214 4.93449 28.6607C5.17381 28.9013 5.50015 29.0357 5.83928 29.0357H19.7925C19.8335 29.0319 19.8744 29.0293 19.9167 29.0293C19.9589 29.0293 19.9998 29.0319 20.0408 29.0357H33.994C34.3332 29.0357 34.6595 28.9013 34.8988 28.6607C35.1394 28.4214 35.2738 28.0951 35.2738 27.7559V26.4775L4.55952 26.4762ZM35.2738 23.9179L4.55952 23.9167V9.83928C4.55952 9.50015 4.6939 9.17381 4.93449 8.93449C5.17381 8.6939 5.50015 8.55952 5.83928 8.55952H33.994C34.3332 8.55952 34.6595 8.6939 34.8988 8.93449C35.1394 9.17381 35.2738 9.50015 35.2738 9.83928V23.9179Z'
      fill='#859CAD'
    />
    <Path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.6369 12.4013V20.0774C18.6369 20.7838 19.2102 21.3571 19.9167 21.3571C20.6231 21.3571 21.1964 20.7838 21.1964 20.0774V12.4013C21.1964 11.6949 20.6231 11.1216 19.9167 11.1216C19.2102 11.1216 18.6369 11.6949 18.6369 12.4013Z'
      fill='#859CAD'
    />
    <Path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.7534 13.6709V18.7899C23.7534 19.4963 24.328 20.0697 25.0331 20.0697C25.7395 20.0697 26.3129 19.4963 26.3129 18.7899V13.6709C26.3129 12.9644 25.7395 12.3911 25.0331 12.3911C24.328 12.3911 23.7534 12.9644 23.7534 13.6709Z'
      fill='#859CAD'
    />
    <Path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.5217 13.6709V18.7899C13.5217 19.4963 14.095 20.0697 14.8014 20.0697C15.5066 20.0697 16.0812 19.4963 16.0812 18.7899V13.6709C16.0812 12.9644 15.5066 12.3911 14.8014 12.3911C14.095 12.3911 13.5217 12.9644 13.5217 13.6709Z'
      fill='#859CAD'
    />
    <Path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M28.8712 14.9507V17.5102C28.8712 18.2166 29.4445 18.7899 30.1509 18.7899C30.8573 18.7899 31.4307 18.2166 31.4307 17.5102V14.9507C31.4307 14.2442 30.8573 13.6709 30.1509 13.6709C29.4445 13.6709 28.8712 14.2442 28.8712 14.9507Z'
      fill='#859CAD'
    />
    <Path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.40393 14.9507V17.5102C8.40393 18.2166 8.97726 18.7899 9.68369 18.7899C10.3901 18.7899 10.9635 18.2166 10.9635 17.5102V14.9507C10.9635 14.2442 10.3901 13.6709 9.68369 13.6709C8.97726 13.6709 8.40393 14.2442 8.40393 14.9507Z'
      fill='#859CAD'
    />
  </Svg>
)
